(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fellomi-video-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){
  const input=event.target;
  if(!(input instanceof HTMLInputElement)||!input.matches('.fm-studio input[data-fm-variant]'))return;
  const root=input.closest('.fm-studio');
  if(!root)return;
  const image=root.querySelector('.fm-studio__product');
  if(image){image.src=input.dataset.image;image.removeAttribute('srcset');image.alt=input.dataset.alt||'';image.classList.remove('is-changing');requestAnimationFrame(function(){image.classList.add('is-changing');});}
  root.querySelector('.fm-studio__hero').style.setProperty('--fm-tone',input.dataset.tone);
  root.querySelector('[data-fm-price]').textContent=input.dataset.price;
  root.querySelector('[data-fm-detail]').href=input.dataset.url;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
